import { CHubSocialVideoInfoFields } from "@app/utils/contenthub";
import { configHome } from "@pub/config";
import { ResponsiveIframe, Typography } from "@sphtech/dmg-design-system";
import { ReactNode } from "react";

import styles from "./videosliderportrait.module.css";

const { Heading } = Typography;

type Props = {
  title: string;
  titleZH?: string;
  cta?: {
    url: string;
    headingIcon?: ReactNode;
  };
  items: CHubSocialVideoInfoFields[];
};

const VideoSliderPortrait = ({ title, titleZH, cta, items }: Props) => {
  return (
    <div className={styles.videoSliderPortrait}>
      <div className={styles.headingTitle}>
        <Heading.SubSectionTitle
          nameZH={titleZH}
          headingUrl={cta?.url}
          target={configHome.socialVideoPortrait?.target}
        >
          {title}
        </Heading.SubSectionTitle>
        {cta?.url && cta.headingIcon}
      </div>

      <div className={styles.sliderContainer}>
        {items.map((item) => {
          return (
            item.videoUrl && (
              <div className={styles.sliderItem}>
                <ResponsiveIframe src={item.videoUrl} loading="lazy" />
              </div>
            )
          );
        })}
      </div>
    </div>
  );
};

export default VideoSliderPortrait;
